import { makeStyles } from '@mui/styles';

type Props = {
  value: string;
};

const useStyles = makeStyles((theme) => ({
  chip: {
    fontSize: theme.typography.pxToRem(14),
    padding: `${theme.spacing(0.5)} ${theme.spacing()}`,
    borderRadius: theme.typography.pxToRem(16),
    backgroundColor: theme.palette.mode === 'light' ? '#16002C0D' : 'rgba(255, 255, 255, 0.09)',
  },
}));

export const Chip = ({ value }: Props) => {
  const classes = useStyles();

  return <div className={classes.chip}>{value}</div>;
};
